//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'selectNode',
    props: {
        onSelected: Function
    },
    data () {
        const vm = this;
        return {
            loading: false,
            selectedNode: null,
            parentId:0,
            parentName:''
        };
    },
    methods: {
        getAllNodes () {
            this.loading = true;
            this.$store.dispatch({
                type: 'node/getAllNodes'
            }).finally(() => {
                this.loading = false;
            });
        },
        renderTree (h, {root, node, data}) {
            const vm = this;
            let typeIcon = 'android-folder-open';
            let color = 'blue';
            return h('span', [
                h('Icon', {
                    props: {
                        type: typeIcon
                    },
                    style: {}
                }),
                h('Button', {
                    props: {type: 'text'}, on: {
                        click () {
                              if (vm.onSelected !== undefined) {
                                    vm.onSelected(data);
                              }
                        }
                    }
                }, data.nodeName)
            ]);
        }
    },
    created () {
         this.getAllNodes();
    },
    computed: {
        selectNodes () {
            return this.$store.state.node.nodes;
        }
    },
    watch: {
        selectedNode (node, oldValue) {
            this.parentId=node.id;
            this.parentName=node.name;
            console.log(node);
        }
    }
};
